import { openModal } from '@core/components/ModalStack';
import { CopyLinkModalProps } from './CopyLinkModal';

export async function openCopyLinkModal(props: CopyLinkModalProps) {
  const { CopyLinkModal } = await import('./CopyLinkModal');

  openModal(CopyLinkModal, props);
}
